import React, { useState } from "react";
import * as gtUtil from "../../../core/utility";

// import { Pie } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { Loading } from "../../../redux/action";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Methods } from '../../../core/utility/methods';
import { Tooltip as MaterialTooltip, TextField } from "@mui/material";
import { BrandDataService } from "../../../core/services/brand-data.service";
import connect from "react-redux/es/components/connect";
import "./brand-data.scss";
import BrandErChart from "./brand-er-chart";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { PieChart } from "../../../components/charts";
import CommonPopUp from "../../../components/popup/common-popup";
import { PublicService } from "../../../core/services";
import InfluencerProfileCard from "../../signup/influencer/influencer-profile-card";
import AddBrandPopup from "./add-brand-popup";
ChartJS.register(ArcElement, Tooltip, Legend);
const brandDataService: BrandDataService = new BrandDataService();
const publicService: PublicService = new PublicService();

const methods = new Methods();

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  data: any;
  brandData:any;
  handleAddCompetitorComparison:any;
  error: string | null;
  handleClose: (ref_id: string) => void
}

interface InstagramProfileData {
  name?: string;
  insta_username?: string;
  profile_picture_url?: string;
  biography?: string;
  followers_count?: number;
  follows?: number;
  total_media?: number;
}
const ComparisionTable: React.FC<Props> = (props: Props) => {
  const donutChartOptions = {
    responsive: false,
    plugins: {
      legend: {
        display: false, // Removes the legend
      },
    },
    cutout: '80%', // This will create a donut effect by cutting out the center
  };

  const generateChartData = (rawData: any[]) => {
    const influencerTypes = [
      "Nano", "Micro", "Micro Plus", "Macro", "Macro Plus", "Mega", "Mega Plus"
    ];
  
    const erMap: { [key: string]: number } = {};
  
    influencerTypes.forEach((type) => {
      const entry = rawData.find((item) => item.influencer_type === type);
      erMap[type] = entry?.average_er || 0;
    });
  
    return {
      labels: influencerTypes,
      datasets: [
        {
          data: influencerTypes.map((type) => erMap[type]),
          backgroundColor: [
            "#FFA5CB", "#FFD232", "#63ABFD", "#1CF7C2",
            "#F45DCE", "#6CDBF3", "#48B4CB"
          ],
          hoverBackgroundColor: [
            "#A53364", "#A6891F", "#36A2EB", "#189661",
            "#D859B8", "#165BAA", "#3F9AAE"
          ],
        }
      ]
    };
  };

  const [removedIds, setRemovedIds] = useState<string[]>([]);
  const [showInputBox, setShowInputBox] = useState(false);
  const [openPopUp,setOpenPopUp] = useState(false);
  const [verified,setVerified] =useState(false);
  // const handleClose = (refId: string) => {
  //   const updated = [...removedIds, refId];
  //   setRemovedIds(updated);
  //   setShowInputBox(props.data.length - updated.length < 3);
  // };
  
  
  const filteredData = props.data.filter(
    (item: any) => !removedIds.includes(item.ref_id)
  );
  const [brandInstaName, setBrandInstaName] = useState('');

  const [handleVerifiedNameData, setHandleVerifiedNameData] = useState<InstagramProfileData>();
  const [handleResponseInfo, setHandleResponseInfo] = useState("")
  const [handleVerifyLoading, setHandleVerifyLoading] = useState(false)

  const handleSubmit = async (event:any) => {
    event.preventDefault();
    const response = await brandDataService.addBrand(brandInstaName);
      if (response.status == gtUtil.Constants.SUCCESS) {
        setBrandInstaName('');
        setHandleResponseInfo(response.info)
        setVerified(false)
      }
      else if (response.status === -3 ){
        setHandleResponseInfo(response.info)
      }
      else{
        setHandleResponseInfo(response.info)
      }

  };
  
    const verifyHandle = async (event:any) => {
      event.preventDefault(); 
      setHandleResponseInfo("")
      setHandleVerifyLoading(true)
      const response = await publicService.instagramVerify(brandInstaName);
      if (response.status == gtUtil.Constants.SUCCESS) {
        
        setHandleVerifyLoading(false)
        setHandleVerifiedNameData(response?.data)
        setVerified(true); 
      }
      else {
        setHandleResponseInfo("Please check the handle name.")
      }

  };

  return (
    
      <section className="brand-insight-highchart brand-insight-highchart-comparison">
        <div className="brand-insight-highchart-top">
          <strong className="brand-insight-highchart-title d-flex flex-column">Competition Analysis
          </strong>
     
            <div className="competitor-image-sec" >
              {
                props.brandData.map((item: any) => {
                  return (
                    <span onClick={()=>{props.handleAddCompetitorComparison(item.ref_id)}} key={item.ref_id} className="competitor-image">
                      <img src={item.gcp_profile_image_url} alt={`${item.insta_name} logo`} height="40px" width="40px" />
                    </span>
                  );
                })
              }
            </div>
            
          <span className="competitor-image-add">
            <MaterialSymbol iconName="add" fontweight="200" fontSize="24px" onClick={()=>{setOpenPopUp(true)}} />
          </span>
        </div>
        {/*
          OLD: this popup posted to /brand/addBrand, which inserted only the username. That left
          priority = 0, bright_data_priority = 0 and service_running = 'false' on the row, so the
          profile-fetch service never picked the brand up. Replaced by AddBrandPopup below, which
          also captures the brand name + industry and sets the service flags.

        {
          openPopUp && 
          <CommonPopUp modalTitle="Add Brand" openModal={openPopUp} onClose={()=>{setOpenPopUp(false)}} className="modal-medium" >
            <form>
              <div className="d-flex mb-3">
              <TextField
                  className='w-100  input-common me-2'
                    size='small'
                  label="Brand's Username"
                  variant='outlined'
                  value={brandInstaName}
                  onChange={(e) => setBrandInstaName(e.target.value)}
                  />
              
              <button className="btn btn-primary btn-mui" onClick ={verifyHandle}>Verify</button>
              </div>
              {verified &&
                <InfluencerProfileCard
                  loading={handleVerifyLoading}
                  platform="instagram"
                  name={handleVerifiedNameData?.name ?? ''}
                  username={handleVerifiedNameData?.insta_username ?? ''}
                  profile_image={handleVerifiedNameData?.profile_picture_url ?? ''}
                  description={handleVerifiedNameData?.biography ?? ''}
                  subscriber={handleVerifiedNameData?.followers_count ?? 0}
                  follows={handleVerifiedNameData?.follows ?? 0}
                  total_media={handleVerifiedNameData?.total_media ?? 0}
                />
                }
              <button className="btn btn-primary" disabled={!verified} onClick={handleSubmit}>
                Add Brand
              </button>
              {handleResponseInfo && <span className="fs-14 d-block mt-2 error">{handleResponseInfo}</span>}

            </form>
           
          </CommonPopUp>
        }
        */}
        {openPopUp && (
          <AddBrandPopup
            openModal={openPopUp}
            user_id={props?.UserReducer?.user_id}
            onClose={() => setOpenPopUp(false)}
          />
        )}
        {props.error && (
            <div className="error fs-14" style={{ marginBottom: '10px',textAlign: 'right',
              paddingRight: '30px' }}>
              {props.error}
            </div>
          )}
        <div className="brand-insight-highchart-data">
          <p style={{ fontSize: '18px', fontWeight: 400, fontFamily: 'Open Sans', lineHeight: '28px', color: '#101828' }}></p>
          <div className="comparison-table d-flex">
            <div className="header-column">
              <div className="header-cell" style={{ height: "140px", visibility: 'hidden' }}>Company</div>
              <div className="header-cell">Followers</div>
              <div className="header-cell">Post Frequency</div>
              <div className="header-cell" style={{ height: '88px' }}>ER
                <div className="d-flex gap-2 flex-wrap">
                  <div className="d-flex gap-1 align-items-baseline">
                    <div style={{ width: '20px', height: '11px', backgroundColor: '#165BAA' }}>

                    </div>
                    <p className="mb-0">All</p>
                  </div>
                  <div className="d-flex gap-1 align-items-baseline"><div style={{ width: '20px', height: '11px', backgroundColor: '#A155B9' }}></div><p className="mb-0">Paid</p></div>
                  <div className="d-flex gap-1 align-items-baseline"><div style={{ width: '20px', height: '11px', backgroundColor: '#189661' }}></div><p className="mb-0">Organic</p></div>
                </div>
              </div>
              <div className="header-cell">Budget
                <p className="mb-0" style={{ color: '#787878', fontSize: '14px' }}>(Monthly/Annually)</p>
              </div>
              <div className="header-cell">EMV
                <p className="mb-0" style={{ color: '#787878', fontSize: '14px' }}>(Last 30 days)</p>
              </div>

              <div className="header-cell" style={{ minHeight: '190px' }}>Influencer Engagement Ratio
                <p style={{ color: '#787878' }}>last 90 days</p>
                <div className="d-flex gap-2 flex-wrap">
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}>
                    <div style={{ width: '20px', height: '20px', backgroundColor: '#FFA5CB',  }}>

                    </div>
                    <p style={{ color: "#5D5D5D", lineHeight:'0.8' }}>Nano <span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400', marginBottom:0 }}>(1k-10k)</span></p>

                  </div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#FFD232' }}></div><p style={{ marginBottom:0, color: "#5D5D5D", lineHeight:'0.8' }}>Micro<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(10K-50K)</span></p></div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#63ABFD' }}></div><p style={{ marginBottom:0, color: "#5D5D5D", lineHeight:'0.8' }}>Micro Plus<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(50K-100K)</span></p></div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#1CF7C2' }}></div><p style={{  color: "#5D5D5D", lineHeight:'0.8' }}>Macro<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(100K-500K)</span></p></div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#F45DCE' }}></div><p style={{ color: "#5D5D5D", lineHeight:'0.8' }}>Macro Plus<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(500K-1M)</span></p></div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#6CDBF3' }}></div><p style={{ marginBottom:0, color: "#5D5D5D", lineHeight:'0.8' }}>Mega<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(1M-5M)</span></p></div>
                  <div className="d-flex gap-1 " style={{minWidth:'100px'}}><div style={{ width: '20px', height: '20px', backgroundColor: '#48B4CB' }}></div><p style={{ color: "#5D5D5D", lineHeight:'0.8' }}>Mega Plus<span style={{ paddingTop:'5px', display: 'block', color: '#5D5D5D', fontWeight: '400' }}>(5M+)</span></p></div>
                </div>
              </div>
            </div>
            <>
            {props.data.map((item: any, index: number) => (
              <div key={item.ref_id} className="header-column competitor-brand-table" style={{ marginRight: '5px', border: '1px solid #C6DCE3', borderRadius: '10px 10px 0 0' }}>
                {index !== 0 && (
                  <span className="competitor-brand-table-close" onClick={() => props.handleClose(item.ref_id)} style={{ cursor: 'pointer' }}>
                    <MaterialSymbol iconName="close" fontweight="200" />
                  </span>
                )}
                <div className="header-cell" style={{ height: '140px', backgroundColor: '#F1F8FB', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                  <img src={item?.profile_data[0]?.gcp_profile_image_url} alt="brand-logo" style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%', marginBottom:'10px' }} />
                  {item.profile_data[0].insta_name}
                </div>
                <div className="header-cell" style={{ borderBottom: '1px solid #EAECF0' }}>
                  <MaterialTooltip arrow title={item?.profile_data[0].followers}>
                    <span>{methods.convertExactNumber(item?.profile_data[0].followers)}</span>
                  </MaterialTooltip>
                </div>
                <div className="header-cell" style={{ borderBottom: '1px solid #EAECF0' }}>
                  {item?.postFrequency[0].total_post?.toFixed(0)}
                </div>
                <div className="header-cell" style={{ borderBottom: '1px solid #EAECF0' }}>
                  <BrandErChart rawData={item.er_data} />
                </div>
                <div className="header-cell" style={{ borderBottom: '1px solid #EAECF0' }}>
                  <div className="d-flex">
                    <MaterialTooltip title={(item?.amount[0]?.total_amount / 3).toFixed(0)} arrow>
                      <span>{methods.formatNumberExactINR(item?.amount[0]?.total_amount / 3)}</span>
                    </MaterialTooltip>
                    /
                    <MaterialTooltip title={(item?.amount[0]?.total_amount * 4).toFixed(0)} arrow>
                      <span>{methods.formatNumberExactINR(item?.amount[0]?.total_amount * 4)}</span>
                    </MaterialTooltip>
                  </div>
                </div>
                  <div className="header-cell" style={{ borderBottom: '1px solid #EAECF0' }}>
                  <span>{methods.formatNumberExactINR(item?.emv[0]?.emv)}</span>
                </div>

                <div className="" style={{ width: "100%", height: "170px", display: 'flex', justifyContent: 'center', paddingTop: '16px' }}>
                  <Doughnut data={generateChartData(item.influencer_engagement)} options={donutChartOptions} width={150} height={150} />
                </div>
              </div>
            ))}

            {showInputBox && (
              <div className="header-column competitor-brand-table" style={{ marginRight: '5px', padding: '20px', border: '1px dashed #C6DCE3', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                
              </div>
            )}
           
          </>
          </div>
        </div>
            
                                  
      </section>
      

  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(ComparisionTable);

export { connectToRedux as ComparisionTable };